import { useEffect, useState } from 'react'
import { Variation } from '../../../../../apiTypes'

export const useManageAiVariationsLoadingSpinner = (existingVariations: Variation[]) => {
	const [texts, setTexts] = useState<string[]>([])

	useEffect(() => {
		const textChangeInterval = setInterval(() => {
			const textsInVariations = existingVariations
				.map((variation) => variation.title + ' ' + variation.description + ' ' + variation.cta)
				.join(' ')

			const text =
				'Native marketing is a dynamic and evolving advertising strategy that' +
				' seamlessly integrates promotional content within the natural flow' +
				" of the platform it's presented on, making it appear less intrusive" +
				' to the audience. There are various forms of native marketing that brands' +
				' utilize to reach their target audience. Sponsored content, for instance, is' +
				' a popular type where brands collaborate with publishers to create articles' +
				" or videos that align with the platform's regular content but highlight the" +
				" brand's message. Similarly, in-feed ads are promotional posts that appear" +
				' within the natural feed of social media platforms or websites, resembling' +
				' regular posts but with a sponsored tag. Branded content, on the other hand, is' +
				' when brands create their own content that tells a story or provides value while' +
				' subtly promoting their product or service. Lastly, content recommendation widgets' +
				' are tools that websites use to suggest related articles to readers, some of which' +
				' are sponsored. Each of these variations offers a unique way to organically reach' +
				' consumers without disrupting their online experience.'

			const words = (textsInVariations || text)
				.split(' ')
				.filter((value) => !!value)
				.map((txt) => txt.toLowerCase().replace(/[^a-zA-Z]/g, ''))

			const pickWord = () => words[Math.floor(Math.random() * words.length)]
			const pickWords = (num: number) =>
				Array(num)
					.fill('_')
					.map(pickWord)
					.join(' ')

			const amount = Math.round(Math.abs(Math.sin(Date.now() / 750)) * 7) + 2
			setTexts(
				Array(5)
					.fill('_')
					.map((_) => pickWords(amount)),
			)
		}, 125)

		return () => clearInterval(textChangeInterval)
	}, [])

	return {
		texts,
	}
}
